/* eslint-disable @typescript-eslint/no-unused-vars */
import { cn } from "@/lib/utils"
import {
  AlertTriangle,
  Info,
  Lightbulb,
  AlertOctagon,
  BookOpen,
} from "lucide-react"
import type { ReactNode } from "react"

interface AdmonitionProps {
  type: "note" | "info" | "tip" | "warning" | "danger"
  title?: string
  children: ReactNode
}

const icons = {
  note: BookOpen,
  info: Info,
  tip: Lightbulb,
  warning: AlertTriangle,
  danger: AlertOctagon,
}

const typeDescriptions = {
  note: "概要",
  info: "情報",
  tip: "ヒント",
  warning: "注意",
  danger: "警告",
}

export function Admonition({ type, title, children }: AdmonitionProps) {
  const Icon = icons[type] || icons.note
  const description = typeDescriptions[type] || "情報"

  return (
    <div
      className={cn(
        "my-6 rounded-lg border-l-4 p-4",
        {
          note: "border-blue-500 bg-blue-50 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
          info: "border-orange-500 bg-orange-50 text-orange-800 dark:bg-orange-900 dark:text-orange-200",
          tip: "border-green-500 bg-green-50 text-green-800 dark:bg-green-900 dark:text-green-200",
          warning:
            "border-yellow-500 bg-yellow-50 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
          danger:
            "border-red-500 bg-red-50 text-red-800 dark:bg-red-900 dark:text-red-200",
        }[type],
      )}
    >
      <div className="flex items-center">
        <Icon className="mr-2 h-5 w-5" />
        <span className="font-bold">{description}</span>
      </div>
      <div className="mt-2">{children}</div>
    </div>
  )
}
